export const PROMO_BAR_BODY_CLASS = 'promoBarIsShown';
export const PROMO_BAR_EXPIRE_DATE_STORAGE = 'promo-bar_expire-date';
export const PROMO_BAR_HEIGHT_CSS_VARIABLE = '--oap-promo-bar-height';
